import type { Locale } from "../Locale.js";

export function getCoursesAnchor(locale: Locale): string {
	return { cs: "#kurzy", en: "#courses" }[locale];
}
